"use client";

// show auth modal if the user is not signed in, instead of navigating to the link
import Link from "@/app/[lang]/_components/Link";
import { api } from "@/trpc/react";
import NextLink from "next/link";
import { Suspense, useContext } from "react";
import { AuthModalContext } from "./AuthModalProvider";

export default function AuthLink({
  href,
  children,
  ...props
}: Parameters<typeof Link>[0]) {
  return (
    <Suspense
      fallback={
        <Link href={href} {...props}>
          {children}
        </Link>
      }
    >
      <AuthLinkContent href={href} {...props}>
        {children}
      </AuthLinkContent>
    </Suspense>
  );
}

function AuthLinkContent({
  href,
  children,
  ...props
}: Parameters<typeof Link>[0]) {
  const { data: user, isLoading } = api.user.findSelf.useQuery();
  const [, setAuthModalOpen] = useContext(AuthModalContext);

  if (isLoading || user)
    return (
      <Link href={href} {...props}>
        {children}
      </Link>
    );

  // NextLink's navigation can be disabled with e.preventDefault
  return (
    <NextLink
      href={href}
      onClick={(e) => {
        // Only prevent default for human interactions
        if (e.type === "click") {
          e.preventDefault();
          setAuthModalOpen(true);
        }
      }}
      {...props}
    >
      {children}
    </NextLink>
  );
}
